/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { FeatureFlagService } from '@pwc/pwc-deals-web-common';
import { useCallback, useRef } from 'react';

export const useAddCommentFlagService = () => {
  const addCommentFlagService = useRef<FeatureFlagService>(
    new FeatureFlagService()
  );

  const addOrRemoveIf = useCallback((shouldAddFlag: boolean, flag: number) => {
    addCommentFlagService.current.addOrRemoveIf(shouldAddFlag, flag);
  }, []);

  const contains = useCallback((flags: number): boolean => {
    return addCommentFlagService.current.has(flags);
  }, []);

  return {
    addOrRemoveIf,
    contains,
  };
};
